export function AppFooter() {
    return (
        <footer className="bg-slate-950 text-slate-500 text-xs py-6 border-t border-slate-900 mt-12">
            <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
                <p>© {new Date().getFullYear()} 인사제도 설계 Framework 디지털 통합 연동 플랫폼. All rights reserved.</p>
                <div className="flex gap-4">
                    <span className="hover:text-slate-300 cursor-pointer">이용약관</span>
                    <span className="hover:text-slate-300 cursor-pointer">개인정보처리방침</span>
                </div>
            </div>
        </footer>
    );
}
